<div style="margin-bottom: 10px;">
 <label>{{label}}</label><br>
{{value}} 
</div>

